import React, { createContext, useState } from 'react';
import { useSignalRConnection } from './SignalRConnectionProvider';
import { useOrganizationData } from './OrganizationDataProvider';
import { isDataLoaded } from '../../types/data-providers';
import { SignalRData } from '../../types/signalr-types';
import { initialSignalRData } from '../../lib/signalr-helper';

type ContextState = SignalRData;

export const Context = createContext<ContextState>(initialSignalRData);

function useSignalRData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSignalRData must be used within a SignalRProvider');
    }
    return contextState;
}

const SignalRDataProvider: React.FC = (props) => {
    const signalRconnection = useSignalRConnection();
    const organizationData = useOrganizationData();
    const [value, setValue] = useState(initialSignalRData);
    React.useEffect(() => {
        if (signalRconnection.connection && isDataLoaded(organizationData)) {
            signalRconnection.connection.on(`notify-${organizationData.value.id}`, (data) => { 
             setValue(data.data);
            });
        }
        return (): void => {
            if (signalRconnection.connection && isDataLoaded(organizationData)) {
                signalRconnection.connection.off(`notify-${organizationData.value.id}`);
            }
        };
    }, [organizationData, signalRconnection.connection]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Context.Provider value={value}>{props.children}</Context.Provider>;
};
export { SignalRDataProvider, useSignalRData };
